import API from "@core/api/api";

//
export const exportPackages = async (params) => {
  const response = await API.get(`/packages/export?${params}`, {
    responseType: "blob", // Ensure the response is treated as binary data
  });
  return response.data;
};

export const addTrackingNumber = async (id, trackingNumber) => {
  const response = await API.put(`/packages/${id}/trackingNumber`, {
    trackingNumber,
  });
  return response.data;
};

/**
 * Fetch packages that are signed and not yet invoiced (nofactured)
 * Returns clients grouped with their non-invoiced signed packages
 */
export const fetchPackageNoFactured = async () => {
  const response = await API.get(`/packages/filter/nofactured`);
  return response.data;
};

/**
 * Alias for fetchPackageNoFactured - gets signed and non-invoiced packages
 */
export const fetchSignedNonInvoicedPackages = fetchPackageNoFactured;

export const fetchPackageById = async (packageId) => {
  const response = await API.get(`/packages/${packageId}`);
  return response.data;
};

export const createPackage = async (packageData) => {
  const response = await API.post(`/packages`, packageData);
  return response.data;
};

export const fetchPackages = async (params) => {
  const response = await API.get(`/packages?${params}`);
  return response.data;
};

//

export const updatePackage = async (id, values) => {
  const response = await API.put(`/packages/${id}`, values);
  return response.data;
};

export const updatePackageStatus = async (id, values) => {
  const response = await API.put(`/packages/updateStatus/${id}`, values);
  return response.data;
};

export const packagesTracking = async (trackingNumber) => {
  const response = await API.get(`/packages/tracking/${trackingNumber}`);
  return response.data;
};

export const trackPackageByIdentifier = async (identifier) => {
  const response = await API.get(`/packages/track-package/${identifier}`);
  return response.data;
};

export const fetchPackagesImported = async (params) => {
  const response = await API.get(`/import/packages?${params}`);
  return response.data;
};

export const updateImportedPackage = async (id, values) => {
  const response = await API.put(`/import/packages/${id}`, values);
  return response.data;
};

export const deleteImportedPackage = async (id) => {
  const response = await API.delete(`/import/packages/${id}`);
  return response.data;
};

export const saveToPackages = async (id) => {
  const response = await API.post(`/import/packages/${id}/create`);
  return response.data;
};

export const createValidPackagesFromImported = async () => {
  const response = await API.post(`/import/packages/create`);
  return response.data;
};

export const deletePackage = async (id) => {
  const response = await API.delete(`/packages/${id}`);
  return response.data;
};

// ** NEW LIVREUR-RELATED API FUNCTIONS **

// Get users by role (Admin/Manager only)
export const getUsersByRole = async (role) => {
  const response = await API.get(`/users?role=${role}`);
  return response.data;
};

// Get all available livreurs (Admin only)
export const getAllLivreurs = async () => {
  const response = await API.get("/packages/admin/livreurs");
  return response.data;
};

// Assign livreur to package (Admin only)
export const assignLivreurToPackage = async (packageId, data) => {
  const response = await API.put(`/packages/${packageId}/assign-livreur`, data);
  return response.data;
};

// Unassign livreur from package (Admin only)
export const unassignLivreurFromPackage = async (packageId, reason = "") => {
  const response = await API.put(`/packages/${packageId}/unassign-livreur`, {
    reason,
  });
  return response.data;
};

// Update package status by livreur (Livreur only)
export const updatePackageStatusByLivreur = async (packageId, data) => {
  const response = await API.put(`/packages/${packageId}/livreur-status`, data);
  return response.data;
};

// Get packages assigned to current livreur (Livreur only)
export const getLivreurPackages = async (params) => {
  const response = await API.get(`/packages/livreur/my-packages?${params}`);
  return response.data;
};

// ** END NEW LIVREUR-RELATED API FUNCTIONS **

// ** PICKUP-RELATED API FUNCTIONS FOR LIVREUR **

// Get pickups assigned to current livreur (Livreur only)
export const getLivreurPickups = async (params) => {
  const response = await API.get(`/pickups/livreur/my-pickups?${params}`);
  return response.data;
};

// Update pickup status by collector (Collector only)
export const updatePickupStatusByCollector = async (pickupId, data) => {
  const response = await API.put(`/pickups/${pickupId}/collector-status`, data);
  return response.data;
};

// Update pickup status by livreur (DEPRECATED - use collector function instead)
export const updatePickupStatusByLivreur = async (pickupId, data) => {
  const response = await API.put(`/pickups/${pickupId}/livreur-status`, data);
  return response.data;
};

// ** END PICKUP-RELATED API FUNCTIONS **

// ** SPEEDAF INTEGRATION **

// Create Speedaf order for a package (Admin, Manager, Livreur)
export const createSpeedafOrder = async (packageId) => {
  const response = await API.post(
    `/packages/${packageId}/create-speedaf-order`
  );
  return response.data;
};

// Retry failed Speedaf order (Admin, Manager, Livreur)
export const retrySpeedafOrder = async (packageId) => {
  const response = await API.post(`/packages/${packageId}/retry-speedaf-order`);
  return response.data;
};

// ** END SPEEDAF INTEGRATION **

// Print Speedaf label (returns PDF blob)
export const printSpeedafLabel = async (packageId) => {
  const response = await API.get(`/packages/${packageId}/print-speedaf-label`, {
    responseType: "blob",
  });
  return response.data;
};

// Print bulk Speedaf labels (returns PDF blob)
export const printBulkSpeedafLabels = async (filters) => {
  const response = await API.post(
    `/packages/print-bulk-speedaf-labels`,
    { filters },
    { responseType: "blob" }
  );
  return response.data;
};

// ** END SPEEDAF PRINT **
